var map = {
	"./chokwin_footer_logo.svg": [
		75240,
		75240
	],
	"./gannar_footer_logo.svg": [
		381,
		381
	],
	"./luckykingbet_footer_logo.svg": [
		841,
		841
	],
	"./mars-br_footer_logo.svg": [
		68677,
		68677
	],
	"./mars-mx_footer_logo.svg": [
		19057,
		71235
	],
	"./mars-pt_footer_logo.svg": [
		20457,
		20457
	],
	"./mars-ru_footer_logo.svg": [
		72625,
		72625
	],
	"./mars-th_footer_logo.svg": [
		43852,
		43852
	],
	"./mars_footer_logo.svg": [
		54037,
		54037
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 77199;
module.exports = webpackAsyncContext;